<template>
  <div :class="`column-select-filter ${field}`">
    <i-select
      v-model="value"
      size="small"
      style="width: 48px"
      :class="value.length ? 'active' : ''"
      :multiple="true"
      prefix="ios-funnel"
      transfer-class-name="column-select-filter-transfer"
      not-found-text="Нет данных"
      :disabled="!!tableLoading"
      filterable
      placeholder="Поиск"
    >
      <i-option
        v-for="item in items"
        :value="item"
        :key="item"
        :disabled="!!tableLoading"
      >
        {{ getLabel(item) }}
      </i-option>
    </i-select>
  </div>
</template>

<script>
export default {
  props: ['type', 'field', 'request', 'values', 'parse-value', 'multiple'],
  computed: {
    items () {
      return this.values
    },
    value: {
      get () {
        return this.$store.state.filters[this.type][this.field]
      },
      set (value) {
        this.$store.commit('CHANGE_FILTER', {
          type: this.type,
          field: this.field,
          value
        })
      }
    },
    tableLoading () {
      return this.$store.state.experience.tableLoading
    }
  },
  methods: {
    async getData () {
      try {
        const url = this.request
        const data = await this.$store.dispatch('GET_REQUEST', { url })
        this.items = [...data]
      } catch (error) {
        console.log(error)
      }
    },
    getLabel (item) {
      if (item === 'null' || item === '') return 'Пусто'
      if (item === 'true') return 'Да'
      if (item === 'false') return 'Нет'

      return item === 'all' ? item : this.parseValue(item)
    }
  },
  created () {
    if (this.request) this.getData()
  }
}
</script>

<style lang="less">
.column-select-filter {
  display: flex;
  align-items: center;

  .active {
    .ivu-select-prefix {
      color: @primary-color;
    }
  }

  &.customer_name {
    .ivu-select.ivu-select-visible {
      .ivu-select-input {
        position: absolute;
        top: -1px;
        left: -4px;
        z-index: 100;
        width: 96px !important;
        border-radius: 4px;
        height: 24px;
        background: #fff;
        border: 1px solid #eee;
      }
    }
  }

  &:not(:first-child) {
    margin-left: 8px;
  }

  .ivu-tag,
  .ivu-select-placeholder {
    display: none !important;
  }

  .ivu-select-selection {
    text-align: left;

    & > div {
      display: flex;
    }
  }
  .ivu-select-prefix {
    padding-left: 0 !important;
    margin-left: 4px;
    margin-top: 4px;
  }

  &-transfer {
    .ivu-select-item {
      padding-right: 32px;
    }
  }
}

.dark {
  .column-select-filter .ivu-select-selection {
    background-color: rgba(@dt-dark-primary, 0.6);
  }

  .column-select-filter.customer_name {
    .ivu-select.ivu-select-visible {
      .ivu-select-input {
        background: @dt-dark-bg;
        border: 1px solid @dt-dark-primary;
      }
    }
  }
}

.light {
  .column-select-filter .ivu-select-selection {
    background-color: rgba(@lt-dark-primary, 0.1);
  }
}
</style>
